export default __webpack_public_path__ + "static/media/ilustracion_fuera_horario.37647265.png";